/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _search_fr = new IntlMessageFormat([{ type: 0, value: 'Rechercher' }], 'fr');

const _search_en = new IntlMessageFormat([{ type: 0, value: 'Search' }], 'en');

export function search(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _search_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _search_en.format(args) as unknown as string;
    }

    return _search_fr.format(args) as unknown as string;
}

const _searching_fr = new IntlMessageFormat([{ type: 0, value: 'Recherche...' }], 'fr');

const _searching_en = new IntlMessageFormat([{ type: 0, value: 'Searching...' }], 'en');

export function searching(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _searching_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _searching_en.format(args) as unknown as string;
    }

    return _searching_fr.format(args) as unknown as string;
}

const _close_fr = new IntlMessageFormat([{ type: 0, value: 'Fermer' }], 'fr');

const _close_en = new IntlMessageFormat([{ type: 0, value: 'Close' }], 'en');

export function close(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _close_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _close_en.format(args) as unknown as string;
    }

    return _close_fr.format(args) as unknown as string;
}

const _inbox_fr = new IntlMessageFormat([{ type: 0, value: 'Messagerie' }], 'fr');

const _inbox_en = new IntlMessageFormat([{ type: 0, value: 'Inbox' }], 'en');

export function inbox(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _inbox_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _inbox_en.format(args) as unknown as string;
    }

    return _inbox_fr.format(args) as unknown as string;
}

const _open_to_inbox_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ouvrir dans la messagerie' }],
    'fr',
);

const _open_to_inbox_en = new IntlMessageFormat(
    [{ type: 0, value: 'Open in inbox' }],
    'en',
);

export function open_to_inbox(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _open_to_inbox_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _open_to_inbox_en.format(args) as unknown as string;
    }

    return _open_to_inbox_fr.format(args) as unknown as string;
}

const _back_to_inbox_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Retour sur la messagerie' }],
    'fr',
);

const _back_to_inbox_en = new IntlMessageFormat(
    [{ type: 0, value: 'Back to inbox' }],
    'en',
);

export function back_to_inbox(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _back_to_inbox_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _back_to_inbox_en.format(args) as unknown as string;
    }

    return _back_to_inbox_fr.format(args) as unknown as string;
}

const _back_to_list_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Retour à la liste' }],
    'fr',
);

const _back_to_list_en = new IntlMessageFormat(
    [{ type: 0, value: 'Back to list' }],
    'en',
);

export function back_to_list(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _back_to_list_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _back_to_list_en.format(args) as unknown as string;
    }

    return _back_to_list_fr.format(args) as unknown as string;
}

const _back_to_return_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Retourner en arrière' }],
    'fr',
);

const _back_to_return_en = new IntlMessageFormat([{ type: 0, value: 'Go back' }], 'en');

export function back_to_return(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _back_to_return_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _back_to_return_en.format(args) as unknown as string;
    }

    return _back_to_return_fr.format(args) as unknown as string;
}

const _cancel_fr = new IntlMessageFormat([{ type: 0, value: 'Annuler' }], 'fr');

const _cancel_en = new IntlMessageFormat([{ type: 0, value: 'Cancel' }], 'en');

export function cancel(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _cancel_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _cancel_en.format(args) as unknown as string;
    }

    return _cancel_fr.format(args) as unknown as string;
}

const _confirm_fr = new IntlMessageFormat([{ type: 0, value: 'Confirmer' }], 'fr');

const _confirm_en = new IntlMessageFormat([{ type: 0, value: 'Confirm' }], 'en');

export function confirm(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _confirm_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _confirm_en.format(args) as unknown as string;
    }

    return _confirm_fr.format(args) as unknown as string;
}

const _confirmation_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Confirmation' }],
    'fr',
);

const _confirmation_en = new IntlMessageFormat(
    [{ type: 0, value: 'Confirmation' }],
    'en',
);

export function confirmation(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _confirmation_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _confirmation_en.format(args) as unknown as string;
    }

    return _confirmation_fr.format(args) as unknown as string;
}

const _save_fr = new IntlMessageFormat([{ type: 0, value: 'Enregistrer' }], 'fr');

const _save_en = new IntlMessageFormat([{ type: 0, value: 'Save' }], 'en');

export function save(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _save_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _save_en.format(args) as unknown as string;
    }

    return _save_fr.format(args) as unknown as string;
}

const _loading_fr = new IntlMessageFormat([{ type: 0, value: 'Chargement' }], 'fr');

const _loading_en = new IntlMessageFormat([{ type: 0, value: 'Loading' }], 'en');

export function loading(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _loading_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _loading_en.format(args) as unknown as string;
    }

    return _loading_fr.format(args) as unknown as string;
}

const _loading_etc_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Chargement...' }],
    'fr',
);

const _loading_etc_en = new IntlMessageFormat([{ type: 0, value: 'Loading...' }], 'en');

export function loading_etc(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _loading_etc_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _loading_etc_en.format(args) as unknown as string;
    }

    return _loading_etc_fr.format(args) as unknown as string;
}

const _submit_fr = new IntlMessageFormat([{ type: 0, value: 'Envoyer' }], 'fr');

const _submit_en = new IntlMessageFormat([{ type: 0, value: 'Submit' }], 'en');

export function submit(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _submit_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _submit_en.format(args) as unknown as string;
    }

    return _submit_fr.format(args) as unknown as string;
}

const _submitting_fr = new IntlMessageFormat([{ type: 0, value: 'Envoi...' }], 'fr');

const _submitting_en = new IntlMessageFormat([{ type: 0, value: 'Submitting...' }], 'en');

export function submitting(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _submitting_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _submitting_en.format(args) as unknown as string;
    }

    return _submitting_fr.format(args) as unknown as string;
}

const _followed_fr = new IntlMessageFormat([{ type: 0, value: 'Suivi' }], 'fr');

const _followed_en = new IntlMessageFormat([{ type: 0, value: 'Followed' }], 'en');

export function followed(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _followed_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _followed_en.format(args) as unknown as string;
    }

    return _followed_fr.format(args) as unknown as string;
}

const _follow_fr = new IntlMessageFormat([{ type: 0, value: 'Suivre' }], 'fr');

const _follow_en = new IntlMessageFormat([{ type: 0, value: 'Follow' }], 'en');

export function follow(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _follow_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _follow_en.format(args) as unknown as string;
    }

    return _follow_fr.format(args) as unknown as string;
}

const _url_of_video_not_valid_fr = new IntlMessageFormat(
    [{ type: 0, value: "L'url de la vidéo n'est pas valide" }],
    'fr',
);

const _url_of_video_not_valid_en = new IntlMessageFormat(
    [{ type: 0, value: 'Video URL is not valid' }],
    'en',
);

export function url_of_video_not_valid(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _url_of_video_not_valid_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _url_of_video_not_valid_en.format(args) as unknown as string;
    }

    return _url_of_video_not_valid_fr.format(args) as unknown as string;
}

const _validate_fr = new IntlMessageFormat([{ type: 0, value: 'Valider' }], 'fr');

const _validate_en = new IntlMessageFormat([{ type: 0, value: 'Validate' }], 'en');

export function validate(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _validate_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _validate_en.format(args) as unknown as string;
    }

    return _validate_fr.format(args) as unknown as string;
}

const _choose_this_video_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Choisir cette vidéo' }],
    'fr',
);

const _choose_this_video_en = new IntlMessageFormat(
    [{ type: 0, value: 'Choose this video' }],
    'en',
);

export function choose_this_video(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _choose_this_video_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _choose_this_video_en.format(args) as unknown as string;
    }

    return _choose_this_video_fr.format(args) as unknown as string;
}

const _choose_video_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Choisir une vidéo' }],
    'fr',
);

const _choose_video_en = new IntlMessageFormat(
    [{ type: 0, value: 'Choose a video' }],
    'en',
);

export function choose_video(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _choose_video_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _choose_video_en.format(args) as unknown as string;
    }

    return _choose_video_fr.format(args) as unknown as string;
}

const _clear_input_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Effacer le champs' }],
    'fr',
);

const _clear_input_en = new IntlMessageFormat([{ type: 0, value: 'Clear field' }], 'en');

export function clear_input(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _clear_input_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _clear_input_en.format(args) as unknown as string;
    }

    return _clear_input_fr.format(args) as unknown as string;
}

const _previous_fr = new IntlMessageFormat([{ type: 0, value: 'Précédent' }], 'fr');

const _previous_en = new IntlMessageFormat([{ type: 0, value: 'Previous' }], 'en');

export function previous(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _previous_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _previous_en.format(args) as unknown as string;
    }

    return _previous_fr.format(args) as unknown as string;
}

const _next_fr = new IntlMessageFormat([{ type: 0, value: 'Suivant' }], 'fr');

const _next_en = new IntlMessageFormat([{ type: 0, value: 'Next' }], 'en');

export function next(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _next_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _next_en.format(args) as unknown as string;
    }

    return _next_fr.format(args) as unknown as string;
}

const _x_minute_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' minute' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' minutes' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

const _x_minute_en = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' minute' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' minutes' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'en',
);

export function x_minute(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_minute_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _x_minute_en.format(args) as unknown as string;
    }

    return _x_minute_fr.format(args) as unknown as string;
}

const _x_hour_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' heure' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' heures' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

const _x_hour_en = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' hour' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' hours' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'en',
);

export function x_hour(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_hour_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _x_hour_en.format(args) as unknown as string;
    }

    return _x_hour_fr.format(args) as unknown as string;
}

const _x_day_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' jour' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' jours' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

const _x_day_en = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' day' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' days' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'en',
);

export function x_day(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_day_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _x_day_en.format(args) as unknown as string;
    }

    return _x_day_fr.format(args) as unknown as string;
}

const _x_week_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' semaine' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' semaines' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

const _x_week_en = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' week' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' weeks' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'en',
);

export function x_week(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_week_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _x_week_en.format(args) as unknown as string;
    }

    return _x_week_fr.format(args) as unknown as string;
}

const _select_participant_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Sélectionne un participant' }],
    'fr',
);

const _select_participant_en = new IntlMessageFormat(
    [{ type: 0, value: 'Select a participant' }],
    'en',
);

export function select_participant(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _select_participant_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _select_participant_en.format(args) as unknown as string;
    }

    return _select_participant_fr.format(args) as unknown as string;
}

const _to_post_fr = new IntlMessageFormat([{ type: 0, value: 'Poster' }], 'fr');

const _to_post_en = new IntlMessageFormat([{ type: 0, value: 'Post' }], 'en');

export function to_post(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _to_post_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _to_post_en.format(args) as unknown as string;
    }

    return _to_post_fr.format(args) as unknown as string;
}

const _is_posting_fr = new IntlMessageFormat(
    [{ type: 0, value: 'En train de poster...' }],
    'fr',
);

const _is_posting_en = new IntlMessageFormat([{ type: 0, value: 'Posting...' }], 'en');

export function is_posting(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _is_posting_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _is_posting_en.format(args) as unknown as string;
    }

    return _is_posting_fr.format(args) as unknown as string;
}

const _open_fr = new IntlMessageFormat([{ type: 0, value: 'Ouvrir' }], 'fr');

const _open_en = new IntlMessageFormat([{ type: 0, value: 'Open' }], 'en');

export function open(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _open_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _open_en.format(args) as unknown as string;
    }

    return _open_fr.format(args) as unknown as string;
}

const _nb_results_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' résultat ' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' résultats' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

const _nb_results_en = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' result ' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' results ' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'en',
);

export function nb_results(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _nb_results_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _nb_results_en.format(args) as unknown as string;
    }

    return _nb_results_fr.format(args) as unknown as string;
}

const _delete__fr = new IntlMessageFormat([{ type: 0, value: 'Supprimer' }], 'fr');

const _delete__en = new IntlMessageFormat([{ type: 0, value: 'Delete' }], 'en');

export function delete_(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _delete__fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _delete__en.format(args) as unknown as string;
    }

    return _delete__fr.format(args) as unknown as string;
}

const _select_file_placeholder_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Choisissez un fichier' }],
    'fr',
);

const _select_file_placeholder_en = new IntlMessageFormat(
    [{ type: 0, value: 'Choose a file' }],
    'en',
);

export function select_file_placeholder(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _select_file_placeholder_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _select_file_placeholder_en.format(args) as unknown as string;
    }

    return _select_file_placeholder_fr.format(args) as unknown as string;
}

const _read_more_fr = new IntlMessageFormat([{ type: 0, value: 'Lire la suite' }], 'fr');

const _read_more_en = new IntlMessageFormat([{ type: 0, value: 'Read more' }], 'en');

export function read_more(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _read_more_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _read_more_en.format(args) as unknown as string;
    }

    return _read_more_fr.format(args) as unknown as string;
}

const _filters_fr = new IntlMessageFormat([{ type: 0, value: 'Filtres' }], 'fr');

const _filters_en = new IntlMessageFormat([{ type: 0, value: 'Filters' }], 'en');

export function filters(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _filters_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _filters_en.format(args) as unknown as string;
    }

    return _filters_fr.format(args) as unknown as string;
}

const _form_data_processing_notice_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Les informations recueillies via ce canal font l’objet d’un traitement de données\npersonnelles destiné à Go Africa Online dans le cadre de la gestion des contacts.\nVous disposez d’un droit d’accès, de modification et de suppression des données\nvous concernant. Pour plus d’informations, veuillez consulter\n[url hrefCode="politique-confidentialite" target="_blank" obfuscate="true"]notre politique de confidentialité[/url].',
        },
    ],
    'fr',
);

const _form_data_processing_notice_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'The information collected through this channel is subject to personal data processing\nintended for Go Africa Online as part of contact management.\nYou have the right to access, modify and delete your personal\ndata. For more information, please consult our\n[url hrefCode="politique-confidentialite" target="_blank" obfuscate="true"]privacy policy[/url].',
        },
    ],
    'en',
);

export function form_data_processing_notice(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _form_data_processing_notice_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _form_data_processing_notice_en.format(args) as unknown as string;
    }

    return _form_data_processing_notice_fr.format(args) as unknown as string;
}
